import React, { useState } from 'react';
import tw from 'twin.macro';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import fetch from 'isomorphic-fetch';
import { Button, H3 } from '../../styles/shared-styled-components';

const Background = () => (
  <div
    tw="absolute right-0 bottom-0 pointer-events-none hidden lg:block"
    aria-hidden="true"
  >
    <svg width="428" height="328" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient
          cx="35.542%"
          cy="34.553%"
          fx="35.542%"
          fy="34.553%"
          r="96.031%"
          id="ni-a"
        >
          <stop stopColor="#DFDFDF" offset="0%" />
          <stop stopColor="#4C4C4C" offset="44.317%" />
          <stop stopColor="#333" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g fill="#FFF">
          <ellipse fillOpacity=".04" cx="185" cy="15.576" rx="16" ry="15.576" />
          <ellipse fillOpacity=".24" cx="100" cy="68.402" rx="24" ry="23.364" />
          <ellipse fillOpacity=".12" cx="29" cy="251.231" rx="29" ry="28.231" />
          <ellipse fillOpacity=".64" cx="29" cy="251.231" rx="8" ry="7.788" />
          <ellipse fillOpacity=".12" cx="342" cy="31.303" rx="8" ry="7.788" />
          <ellipse fillOpacity=".48" cx="62" cy="126.811" rx="2" ry="1.947" />
          <ellipse fillOpacity=".12" cx="78" cy="7.072" rx="2" ry="1.947" />
          <ellipse fillOpacity=".64" cx="185" cy="15.576" rx="6" ry="5.841" />
        </g>
        <circle fill="url(#ni-a)" cx="276" cy="237" r="200" />
      </g>
    </svg>
  </div>
);

export const Newsletter = () => {
  const [success, setSuccess] = useState(false);
  const { handleSubmit, register } = useForm({
    resolver: yupResolver(yup.object().shape({ email: yup.string().email() })),
  });

  const onSubmit = async ({ email }) => {
    console.log(process.env.GATSBY_SIB_SECRET);
    const url = 'https://api.sendinblue.com/v3/contacts';
    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'api-key': process.env.GATSBY_SIB_SECRET!,
      },
      body: JSON.stringify({ updateEnabled: false, email }),
    };

    const response = await fetch(url, options);
    const data = await response.json();
    if (data.id) {
      setSuccess(true);
    }
  };

  return (
    <section tw="mt-12 text-white max-w-6xl mx-auto px-4 sm:px-6 pb-12 md:pb-20">
      <div
        tw="relative bg-gray-900 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden"
        data-aos="zoom-y-out"
      >
        <Background />
        <div tw="relative lg:flex-row justify-between items-center text-center lg:text-left lg:max-w-xl">
          <H3 tw="mb-4">Sign up for the beta</H3>
          <p tw="text-gray-300 text-lg mb-6">
            Playflow is available in beta. Add yourself to our early-access list
            to be one of the first to use it.
          </p>
          {/* CTA form */}
          <form
            onSubmit={handleSubmit(onSubmit)}
            tw="w-full lg:w-auto text-lg justify-center max-w-xs mx-auto sm:max-w-md lg:mx-0"
          >
            <input
              type="email"
              tw="mb-4 w-full appearance-none bg-gray-800 border border-gray-700 focus:border-gray-600 rounded-sm px-4 py-3 sm:mr-2 text-white placeholder-gray-500"
              placeholder="Your Spotify email…"
              aria-label="Your email…"
              required
              {...register('email')}
            />
            <Button
              tw="font-bold bg-green-500 hover:bg-green-700 shadow whitespace-nowrap"
              href="#0"
              type="submit"
            >
              Request early access
            </Button>
          </form>
          {success && (
            <p tw="text-lg mt-4">Thank you. You're now on the waiting list!</p>
          )}
        </div>
      </div>
    </section>
  );
};
